import React, { useEffect, useState } from "react";
import api, { apiErr, uploadFile, fileUrl } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { F } from "@/pages/Employees";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Settings() {
  const [form, setForm] = useState({
    nama_perusahaan: "", alamat: "", telepon: "", email: "", no_wa: "", website: "", logo_text: "CPS",
    penandatangan_admin: "", penandatangan_manager: "", kasbon_plafon_hari: 26,
    jam_kerja_standar: 8, durasi_istirahat: 1, jam_masuk_standar: "08:00", toleransi_telat_menit: 0,
    kas_kecil_ambang_minimum: 500000, batas_lembur_harian: 4, logo_path: "",
  });

  useEffect(() => { api.get("/settings").then((r) => setForm((f) => ({ ...f, ...r.data }))); }, []);

  const save = async () => {
    try { await api.put("/settings", form); toast.success("Pengaturan tersimpan"); }
    catch (e) { toast.error(apiErr(e)); }
  };

  const logoUpload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    try { const r = await uploadFile(f, "logo"); setForm((x) => ({ ...x, logo_path: r.path })); toast.success("Logo diunggah"); }
    catch (err) { toast.error(apiErr(err)); }
    e.target.value = "";
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Pengaturan Perusahaan" subtitle="Informasi perusahaan untuk slip gaji & laporan" />
      <Card className="p-5 max-w-2xl space-y-3">
        <div className="flex items-center gap-4 border-b pb-4">
          <img src={form.logo_path ? fileUrl(form.logo_path) : "/logo.png"} alt="logo" className="h-16 w-16 rounded-lg border object-contain bg-white p-1" data-testid="set-logo-preview" />
          <div className="space-y-1">
            <div className="text-sm font-medium text-slate-700">Logo Perusahaan</div>
            <div className="flex gap-3 text-sm">
              <label className="text-blue-700 underline cursor-pointer">
                <input type="file" accept="image/*" className="hidden" data-testid="set-logo" onChange={logoUpload} />
                {form.logo_path ? "Ganti Logo" : "Unggah Logo"}
              </label>
              {form.logo_path && <button className="text-rose-600" data-testid="set-logo-del" onClick={() => setForm({ ...form, logo_path: "" })}>Hapus</button>}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <F label="Nama Perusahaan"><Input data-testid="set-nama" value={form.nama_perusahaan} onChange={(e) => setForm({ ...form, nama_perusahaan: e.target.value })} /></F>
          <F label="Logo Teks (mis. CPS)"><Input value={form.logo_text} onChange={(e) => setForm({ ...form, logo_text: e.target.value })} /></F>
          <F label="Telepon"><Input data-testid="set-telepon" value={form.telepon} onChange={(e) => setForm({ ...form, telepon: e.target.value })} /></F>
          <F label="No. WA"><Input data-testid="set-no-wa" value={form.no_wa} onChange={(e) => setForm({ ...form, no_wa: e.target.value })} /></F>
          <F label="Email"><Input data-testid="set-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></F>
          <F label="Website"><Input data-testid="set-website" value={form.website} onChange={(e) => setForm({ ...form, website: e.target.value })} /></F>
          <F label="Penandatangan (Admin)"><Input value={form.penandatangan_admin} onChange={(e) => setForm({ ...form, penandatangan_admin: e.target.value })} /></F>
          <F label="Penandatangan (Manager)"><Input value={form.penandatangan_manager} onChange={(e) => setForm({ ...form, penandatangan_manager: e.target.value })} /></F>
          <F label="Plafon Kasbon (hari gaji/bulan)"><Input type="number" data-testid="set-plafon" value={form.kasbon_plafon_hari} onChange={(e) => setForm({ ...form, kasbon_plafon_hari: Number(e.target.value) })} /></F>
          <F label="Jam Kerja Standar / hari"><Input type="number" step="0.5" data-testid="set-jam-standar" value={form.jam_kerja_standar} onChange={(e) => setForm({ ...form, jam_kerja_standar: Number(e.target.value) })} /></F>
          <F label="Durasi Istirahat (jam)"><Input type="number" step="0.5" data-testid="set-istirahat" value={form.durasi_istirahat} onChange={(e) => setForm({ ...form, durasi_istirahat: Number(e.target.value) })} /></F>
          <F label="Jam Masuk Standar (absen telat)"><Input type="time" data-testid="set-jam-masuk-standar" value={form.jam_masuk_standar} onChange={(e) => setForm({ ...form, jam_masuk_standar: e.target.value })} /></F>
          <F label="Toleransi Telat (menit)"><Input type="number" data-testid="set-toleransi-telat" value={form.toleransi_telat_menit} onChange={(e) => setForm({ ...form, toleransi_telat_menit: Number(e.target.value) })} /></F>
          <F label="Ambang Saldo Kas Kecil Menipis (Rp)"><Input type="number" data-testid="set-kas-ambang" value={form.kas_kecil_ambang_minimum} onChange={(e) => setForm({ ...form, kas_kecil_ambang_minimum: Number(e.target.value) })} /></F>
          <F label="Batas Wajar Lembur / hari (jam)"><Input type="number" step="0.5" data-testid="set-batas-lembur" value={form.batas_lembur_harian} onChange={(e) => setForm({ ...form, batas_lembur_harian: Number(e.target.value) })} /></F>
          <div className="sm:col-span-2"><F label="Alamat"><Textarea value={form.alamat} onChange={(e) => setForm({ ...form, alamat: e.target.value })} /></F></div>
        </div>
        <Button className="bg-blue-800 hover:bg-blue-900" onClick={save} data-testid="set-save-btn">Simpan Pengaturan</Button>
      </Card>
    </div>
  );
}
